import * as React from "react";
const SvgFiBrandsFacebookMessenger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-facebook-messenger_svg__a)">
      <path
        fill="#151A2D"
        fillRule="evenodd"
        d="M12 0C5.24 0 0 4.952 0 11.64c0 3.498 1.434 6.522 3.769 8.61a.96.96 0 0 1 .323.684l.065 2.134a.96.96 0 0 0 1.347.849l2.382-1.051a.96.96 0 0 1 .641-.047c1.094.301 2.259.461 3.473.461 6.76 0 12-4.952 12-11.64S18.76 0 12 0m7.206 8.956-3.525 5.593a1.8 1.8 0 0 1-2.603.48l-2.804-2.103a.72.72 0 0 0-.867.003L5.62 15.802c-.505.383-1.165-.221-.827-.758l3.525-5.593a1.8 1.8 0 0 1 2.603-.48l2.804 2.103a.72.72 0 0 0 .867-.003l3.787-2.873c.506-.383 1.165.221.827.758"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-facebook-messenger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFacebookMessenger;
